// Revisions are decimal strings: converting them to Number loses ordering
// beyond Number.MAX_SAFE_INTEGER. Invalid metadata must not replace a known
// revision during reconciliation of HTTP snapshots and realtime updates.
export const compareRecommendRevisions = (
  left: string,
  right: string
): -1 | 0 | 1 | null => {
  if (!/^\d+$/.test(left) || !/^\d+$/.test(right)) return null;

  const normalizedLeft = left.replace(/^0+(?=\d)/, '');
  const normalizedRight = right.replace(/^0+(?=\d)/, '');

  if (normalizedLeft.length !== normalizedRight.length) {
    return normalizedLeft.length > normalizedRight.length ? 1 : -1;
  }

  if (normalizedLeft === normalizedRight) return 0;

  return normalizedLeft > normalizedRight ? 1 : -1;
};
